// This is to convert old icon names to new fontawesome icon names - it can be change when we close the old portal
export const mapOldIconToNew = (oldIcon: string): string | undefined => {
  const iconMap: { [key: string]: string } = {
    'person-circle': 'user',
    'file-earmark-text': 'file-lines',
    'house-door-fill': 'house',
    headphones: 'headphones',
    newspaper: 'newspaper',
    'pencil-fill ': 'pencil',
    tools: 'screwdriver-wrench',
    'play-btn-fill': 'circle-play',
    book: 'book-open',
    'people-fill': 'users',
    'question-circle-fill': 'circle-question',
    'cloud-download': 'cloud-arrow-down',
    calendar: 'calendar',
    building: 'city',
    'magnifying-glass': 'magnifying-glass'
  }

  return iconMap[oldIcon]
}
